import { createAction, props } from '@ngrx/store';
import { ID } from 'src/app/core/definitions/types';
import { IntegrationDetail } from 'src/app/core/interfaces/integration-detail.interface';

export const getIntegrations = createAction('[Integrations] Get Integrations');
export const getIntegrationsSuccess = createAction('[Integrations] Get Integrations Success', props<{ integrations: IntegrationDetail[] }>());
export const getIntegrationsFail = createAction('[Integrations] Get Integrations Fail', props<{ error: IntegrationDetail }>());

export const deleteIntegration = createAction('[Integrations] Delete Integration', props<{ id: ID }>());
export const deleteIntegrationSuccess = createAction('[Integrations] Delete Integration Success', props<{ id: ID }>());
export const deleteIntegrationFail = createAction('[Integrations] Delete Integration Fail', props<{ error: IntegrationDetail }>());

export const setDraft = createAction('[Integrations] Set Draft', props<{ draft: IntegrationDetail }>());
export const setCurrent = createAction('[Integrations] Set Current', props<{ current: IntegrationDetail }>());

export const upsertIntegration = createAction('[Integrations] Upsert Integration', props<{ integration: IntegrationDetail, isDraft: boolean }>());
export const upsertIntegrationSuccess = createAction('[Integrations] Upsert Integration Success', props<{ isDraft: boolean, integration: IntegrationDetail }>());
export const upsertIntegrationFail = createAction('[Integrations] Upsert Integration Fail', props<{ error: IntegrationDetail }>());

export const integrationChangesDiscardDraft = createAction('[Integrations] Integration Changes Discard Draft');
export const resetModuleState = createAction('[Integrations] Reset Module State');
export const integrationChangesDiscard = createAction('[Integrations] Integration Changes Discard');


export const createIntegrationDraft = createAction('[Integrations] Create Integration Draft', props<{ draft: IntegrationDetail }>());
export const deleteIntegrationDraft = createAction('[Integrations] Delete Integration Draft', props<{ id: ID }>());

export const saveIntegration = createAction('[Integrations] Save Integration', props<{ integration: IntegrationDetail }>());


export const getIntegrationsHealth = createAction('[Integrations] Get Integrations Health');
export const getIntegrationsHealthSuccess = createAction('[Integrations] Get Integrations Health Success', props<{ healthStatuses: Record<string, string> }>());
export const getIntegrationsHealthFail = createAction('[Integrations] Get Integrations Health Fail', props<{ error: string }>());